<template>
  <auth-layout>
    <div class="w-full md:w-3/5 mx-auto text-darkBlue px-3 sm:w-4/5">
      <div class="flex justify-center my-6">
        <img src="../assets/forgot-password.svg" />
      </div>
      <div class="text-center">
        <p class="font-semibold text-lg">Password Reset</p>
      </div>
      <div class="text-justify py-2">
        <small
          >Enter the email associated with your account and we will send an
          email with instructions to reset your password.</small
        >
      </div>
      <div class="mt-2">
        <label class="label font-semibold">Email</label>
        <base-input
          placeholder="Enter Your Email"
          errorText="Please enter a valid email Address"
          v-model="email"
          :validation="
            /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(
              email
            )
          "
          @valid="isValidEmail = true"
          @invalid="isValidEmail = false"
        >
          <template v-slot:icon>
            <svg
              width="19"
              height="14"
              viewBox="0 0 19 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M16.941 0.283447H1.96132C1.63025 0.283447 1.31273 0.417552 1.07863 0.656259C0.84453 0.894966 0.713013 1.21872 0.713013 1.55631V11.7392C0.713013 12.0768 0.84453 12.4005 1.07863 12.6392C1.31273 12.8779 1.63025 13.012 1.96132 13.012H16.941C17.272 13.012 17.5896 12.8779 17.8237 12.6392C18.0578 12.4005 18.1893 12.0768 18.1893 11.7392V1.55631C18.1893 1.21872 18.0578 0.894966 17.8237 0.656259C17.5896 0.417552 17.272 0.283447 16.941 0.283447ZM15.5678 1.55631L9.45114 5.8713L3.33445 1.55631H15.5678ZM1.96132 11.7392V2.13546L9.09538 7.16962C9.19986 7.24352 9.32398 7.28313 9.45114 7.28313C9.5783 7.28313 9.70243 7.24352 9.80691 7.16962L16.941 2.13546V11.7392H1.96132Z"
                fill="#FCC210"
              />
            </svg>
          </template>
        </base-input>
      </div>

      <div class="mt-3">
        <base-button
          text="Reset"
          width="w-full"
          p="py-2"
          :loading="loading"
          @click="submitEmail"
          :disable="!isValidEmail"
        />
      </div>

      <div class="text-center mt-4">
        <small>
          Don't have an account?
          <span>
            <router-link to="/signup">Sign Up</router-link>
          </span>
        </small>
      </div>
    </div>
  </auth-layout>
</template>

<script>
import AuthLayout from '../Authlayout/OnDemand'

export default {
  components: {
    AuthLayout,
  },
  data() {
    return {
      currentTab: 'LoginForm',
      email: '',
      isValidEmail: false,
      loading: false,
    }
  },
  methods: {
    async submitEmail() {
      this.loading = true
      let requestObject = {
        email: this.email,
        link:'http://mulex-dev.s3-website.eu-west-2.amazonaws.com/reset-password',
      }
      try {
        await this.$_getResetPasswordLink(requestObject)
        this.handleSuccessfulResponse()
      } catch (error) {
        this.handleError(error)
      }
      this.loading = false
    },
    handleSuccessfulResponse() {
      this.generateToast(
        'A recovery link has been sent to your email!',
        'success'
      )
      this.resetLinkSent = true
      this.submittingEmail = false
    },
  },
}
</script>

<style scoped></style>
